import { Component, input, InputSignal } from '@angular/core';

import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ReferralInputWithRevertComponent } from '../Input-With-Revert/referralInputWithRevert.component';
import { ButtonRadioDirective } from 'ngx-bootstrap/buttons';

@Component({
    selector: 'referral-overview',
    templateUrl: 'referralOverview.component.html',
    styleUrls: ['../referralPage.component.scss'],
    imports: [ReactiveFormsModule, ReferralInputWithRevertComponent],
})
export class ReferralOverviewComponent {
    referral: InputSignal<Core.LitigationReferralModel> = input<Core.LitigationReferralModel>();
    systemReferral: InputSignal<Core.LitigationReferralModel> = input<Core.LitigationReferralModel>();
    originalReferral: InputSignal<Core.LitigationReferralModel> = input<Core.LitigationReferralModel>();
    form: InputSignal<FormGroup> = input<FormGroup>();

    rlsCasePriorityOptions: Weissman.Model.NameValuePair[] = [
        { name: '', value: '' },
        { name: 'Standard', value: Core.RLSCasePriorityEnum.Standard.toString() },
        { name: 'Expedited', value: Core.RLSCasePriorityEnum.Expedited.toString() },
        { name: 'Emergency', value: Core.RLSCasePriorityEnum.Emergency.toString() },
    ];
}
